import { CommunicationProvider } from "@/lib/CommunicationWrapper";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { AccountTab } from "./AccountTab";
import { NotificationsTab } from "./NotificationsTab";
import { PrivacyTab } from "./PrivacyTab";
import { BillingTab } from "./BillingTab";
import { Bell, CreditCard, Shield, User } from "lucide-react";
import { ThemeWrapper, WithTheme } from "@/lib/WithTheme";

type SettingsTab = "account" | "notifications" | "privacy" | "billing";

export const SettingsPageContent = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const initialTab = searchParams.get("tab") || "account";
    const [activeTab, setActiveTab] = useState<SettingsTab>(initialTab as SettingsTab);

    useEffect(() => {
        if (initialTab) {
            setActiveTab(initialTab as SettingsTab);
        }
    }, [initialTab]);

    return (
        <div className="w-full h-full bg-theme-0 rounded-lg flex gap-2 text-theme-0 overflow-hidden">
            <div className="rounded-xl p-4 flex flex-col gap-2 min-w-max m-3" style={{ "backdropFilter": "invert(.03)" }}>
                <p className="text-theme-0 text-xl font-bold ml-2 mb-2">Settings</p>
                <button className={`flex items-center gap-2 cursor-pointer px-3 py-2 pr-12 w-full text-left rounded-xl border transition-all duration-200 ${activeTab === "account" ? "bg-theme-0 text-theme-0 border-theme" : "border-transparent hover:bg-theme-1"}`} onClick={() => setActiveTab("account")}><User className="size-4" /> Account</button>
                <button className={`flex items-center gap-2 cursor-pointer px-3 py-2 pr-12 w-full text-left rounded-xl border transition-all duration-200 ${activeTab === "notifications" ? "bg-theme-0 text-theme-0 border-theme" : "border-transparent hover:bg-theme-1"}`} onClick={() => setActiveTab("notifications")}><Bell className="size-4" /> Notifications</button>
                <button className={`flex items-center gap-2 cursor-pointer px-3 py-2 pr-12 w-full text-left rounded-xl border transition-all duration-200 ${activeTab === "privacy" ? "bg-theme-0 text-theme-0 border-theme" : "border-transparent hover:bg-theme-1"}`} onClick={() => setActiveTab("privacy")}><Shield className="size-4" /> Privacy</button>
                <button className={`flex items-center gap-2 cursor-pointer px-3 py-2 pr-12 w-full text-left rounded-xl border transition-all duration-200 ${activeTab === "billing" ? "bg-theme-0 text-theme-0 border-theme" : "border-transparent hover:bg-theme-1"}`} onClick={() => setActiveTab("billing")}><CreditCard className="size-4" /> Plan and Billing</button>
            </div>
            <div className="flex-1 max-w-[700px] w-full mx-auto p-6 overflow-y-auto h-full">
                {activeTab === "account" && <AccountTab />}
                {activeTab === "notifications" && <NotificationsTab />}
                {activeTab === "privacy" && <PrivacyTab />}
                {activeTab === "billing" && <BillingTab />}
            </div>
        </div>
    )
}

export const SettingsPage = () => {

    return (
        <CommunicationProvider>
            <WithTheme />
            <SettingsPageContent />
        </CommunicationProvider>
    )
}